import React from "react";
import { Input } from "reactstrap";
import Loading from "../../Loading";

const DispositivosList = (props) => {
  const sit = (situacao) => {
    switch (situacao) {
      case "2":
        return <td className="text-center">Extravio</td>;
      case "21":
        return <td className="text-center">Furto</td>;
      case "22":
        return <td className="text-center">Roubo</td>;
      case "23":
        return <td className="text-center">Recuperado</td>;
      case "41":
        return <td className="text-center">Estelionato</td>;
      case "81":
        return <td className="text-center">Apropriação Indébita</td>;
      default:
        return <td className="text-center">&nbsp;</td>;
    }
  };

  const isEnabledConfirmar = (index) => {
    return !props.list[index].updated;
  };

  const list = () => {
    let lista = props.list;
    return lista.map((item, index) => (
      <tr key={item.id}>
        <td>{item.imei}</td>
        <td>{item.numero_bo}</td>
        <td>
          <a href className="text-link" onClick={() => props.userInfo(item.user)}>
            {item.user.cpf}
          </a>
        </td>
        <td>{item.serial !== null ? item.serial : "Não informado"}</td>
        {sit(item.situacao)}
        <td>
          <Input
            type="select"
            className="form-control"
            onChange={(e) => props.onChangeSituacao(e, item.id)}
            id="situacao"
          >
            <option value="0">Selecione</option>
            <option value="2">Extravio</option>
            <option value="21">Furto</option>
            <option value="22">Roubo</option>
            <option value="23">Recuperado</option>
            <option value="41">Estelionato</option>
            <option value="81">Apropriação Indébita</option>
          </Input>
        </td>
        <td>
          <button
            type="button"
            className={isEnabledConfirmar(index) ? "btn" : "btn btn-primary"}
            disabled={isEnabledConfirmar(index)}
            onClick={() => props.showModalConfirm(item)}
          >
            Confirmar
          </button>
          &nbsp;
          <button
            type="button"
            className="btn btn-danger"
            onClick={() => {
              props.setDispositivo(item.id);
              props.showModal(item);
            }}
          >
            Indeferir
          </button>
        </td>
      </tr>
    ));
  };

  return (
    <div>
      <table className="table table-responsive-sm table-responsive-md table-responsive-lg table-dispositivos">
        <thead>
          <tr>
            <th>IMEI Celular</th>
            <th>Número B.O</th>
            <th>CPF</th>
            <th>Serial</th>
            <th>Situação declarada</th>
            <th>Situação</th>
            <th>
              <button type="button" className="btn btn-primary" onClick={props.reload}>
                <i className="fa fa-sync-alt"></i>
                &nbsp;Atualizar
              </button>
            </th>
          </tr>
        </thead>
        <tbody>{props.loadList ? list() : null}</tbody>
      </table>
      {!props.loadList ? (
        <div style={{ paddingLeft: "50%" }}>
          <Loading />
        </div>
      ) : null}
    </div>
  );
};

export default DispositivosList;



// WEBPACK FOOTER //
// ./src/components/Admin/DispositivosList/index.js